import React from 'react';
import { Alert, Typography } from '@mui/material';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { useTranslation } from 'react-i18next';
import { useStorefrontContext } from 'context/StorefrontContext';
import { isStorePaused, storePauseMessage } from 'utils/storePause';

const StorePausedBanner: React.FC = () => {
  const { features, loading } = useStorefrontContext();
  const { t } = useTranslation('common');

  if (loading || !isStorePaused(features)) return null;

  return (
    <Alert
      severity="warning"
      icon={<PauseCircleOutlineIcon fontSize="inherit" />}
      sx={{ borderRadius: 0, alignItems: 'center', '& .MuiAlert-message': { py: 0.25 } }}
    >
      <Typography component="span" fontWeight={700}>
        {t('storePaused.title')}
      </Typography>
      {'. '}
      {storePauseMessage(features, t('storePaused.defaultMessage'))}
    </Alert>
  );
};

export default StorePausedBanner;
